import { StyledWizardModalContentWrapper } from "./styles";
import type { PropsWithChildren } from "react";
import WizardErrorContent
    from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/components/WizardErrorContent/WizardErrorContent";

interface Props {
    isError?: boolean
}

const WizardModalContent = ({ isError, children }: PropsWithChildren<Props>) => {
    if (isError) {
        return (
            <StyledWizardModalContentWrapper>
                <WizardErrorContent />
            </StyledWizardModalContentWrapper>
        );
    }

    return (
        <StyledWizardModalContentWrapper>
            {children}
        </StyledWizardModalContentWrapper>
    )
}

export default WizardModalContent;